module.exports = __webpack_public_path__ + "img/Business.7a3874dc.svg";